import React, { useState, useEffect } from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core'
import collectionSettingsData from './data'
import { useParams } from 'react-router-dom'
import SettingsNavigation from './components/settings-navigation'
import LearnerAccess from './components/learner-access'
import Certification from './components/certification'
import CustomDomain from 'src/components/custom-domain'
import GeneralSettings from './components/general-settings'
import WhiteLabeling from './components/white-label'
// Import other components as they become available

const CollectionSettings = props => {
  const { classes } = props
  const { id, subPage } = useParams()
  const [activeItem, setActiveItem] = useState(subPage)

  useEffect(() => {
    setActiveItem(subPage)
  }, [subPage])
  const renderComponent = () => {
    switch (activeItem) {
      case 'learner-authentication':
        return <LearnerAccess />
      case 'custom-domain':
        return <CustomDomain /> // Placeholder until component is created
      case 'certification':
        return <Certification />
      case 'general':
        return <GeneralSettings /> // Placeholder until component is created
      case 'white-labeling':
        return <WhiteLabeling /> // Placeholder until component is created
      default:
        return <div>Select a setting from the left menu</div>
    }
  }

  return (
    <div className={classes.root}>
      <SettingsNavigation
        items={collectionSettingsData}
        activeItem={activeItem}
        collectionId={id}
      />
      <div className={classes.content}>{renderComponent()}</div>
    </div>
  )
}

export default withStyles(styles)(CollectionSettings)
